import { Component, OnInit, TemplateRef, ViewChild } from "@angular/core";
import { AppService } from "../services/app.service";
import { environment } from "../../environments/environment";
import { checkDate as checkDateUtil } from "../utils/format-util";
import {
  IMyDrpOptions,
  IMyDateRangeModel,
  IMyDateRange,
} from "mydaterangepicker";
import { MyDatePicker, IMyDpOptions, IMyDateModel } from "mydatepicker";
import { ToastrService } from "ngx-toastr";
import { EventInput, Calendar } from "@fullcalendar/core";
import dayGridPlugin from "@fullcalendar/daygrid";
import { BsModalService, BsModalRef } from "ngx-bootstrap/modal";
import $ from "jquery";
import * as moment from "moment";

// import resourceTimeGridPlugin from '@fullcalendar/resource-timegrid';
declare var $: any;
const days = [
  { id: 1, name: "monDay", value: "Monday" },
  { id: 1, name: "tueDay", value: "Tuesday" },
  { id: 1, name: "wedDay", value: "Wednesday" },
  { id: 1, name: "thuDay", value: "Thursday" },
  { id: 1, name: "friDay", value: "Friday" },
  { id: 1, name: "satDay", value: "Saturday" },
  { id: 1, name: "sunDay", value: "Sunday" },
];
@Component({
  selector: "app-work-hours",
  templateUrl: "./work-hours.component.html",
})
export class WorkHoursComponent implements OnInit {
  allTechnician = [];
  today: any = new Date();
  calenderToday: any = new Date();
  currentDate: number;
  currentMonth: number;
  currentYear: number;
  selectedbeginDateformatted = "";
  selectedendDateformatted = "";
  public myDateRangePickerOptions: IMyDrpOptions = {};
  public myDatePickerOptions: IMyDpOptions = {};
  selectedDateRange: IMyDateRange = null;
  workHoursCalenderData: EventInput[] = [];
  workHoursCalenderDataOff = [];
  excludedDate = "";
  disableDaysArray = [];
  disableDateRangeArray = [];
  workFromTimeArray = environment.initialTimeNewObject;
  workToTimeArray = environment.initialTimeNew;
  lunchFromTimeArray = environment.initialTimeNew;
  lunchToTimeArray = environment.initialTimeNew;
  addedTechWorkHoursArray = [];
  emptyTechWrokHoursArray = [];
  currentSelectedRange: any;
  endDate = "";
  beginDate = "";
  workFromTime = "";
  workToTime = "";
  lunchFromTime = "";
  lunchToTime = "";
  selectedTechnicianId = "";
  selectTechId = "";
  selectTechIdView = "";
  viewTechWorkHours = [];
  selectTechIdView1 = "";
  editTechWorkHoursData = false;
  viewAllTechWorkHours = [];
  viewAllOff = [];
  calender;
  searchTech = "";
  searchTechView = "";
  selectTechIdViewFName = "";
  selectTechIdViewLName = "";
  selectedWorkHoursFromIndex: any;
  selectedWorkHoursToIndex: any;
  selectedLunchHoursFromIndex: any;
  selectedLunchHoursToIndex: any;
  beginJsDate: any;
  endJsDate: any;
  jsdate: any;
  viewRangeCalender = false;
  modalRef: BsModalRef;
  config = {
    ignoreBackdropClick: true,
  };
  eventInfoData = "Test";
  showErrorMessage = "";
  showSuccessMessage = "";
  workingHours: any = [];
  fromHourslowValue = 0;
  toHoursHighValue = 0;
  objectKeys = Object.keys;
  toWorkHoursArrayNew = {};
  time1 = "";
  time2 = "";
  time3 = "";
  time4 = "";
  selectedTime1Object: any;
  selectedTime2Object: any;
  selectedTime3Object: any;
  selectedTime4Object: any;
  calendarTitle: any = null;

  @ViewChild("template") template: TemplateRef<any>;

  constructor(
    private appservice: AppService,
    private toastr: ToastrService,
    private modalService: BsModalService
  ) {
    this.today.setHours(0, 0, 0, 0);
    this.currentDate = this.today.getDate() - 1;
    this.currentMonth = this.today.getMonth() + 1;
    this.currentYear = this.today.getFullYear();

    this.myDateRangePickerOptions = {
      // other options...
      dateFormat: "mmm dd, yyyy",
      minYear: +this.currentYear,
      firstDayOfWeek: "su",
      disableUntil: {
        year: +this.currentYear,
        month: +this.currentMonth,
        day: +this.currentDate,
      },
      showClearDateRangeBtn: false,
      showClearBtn: false,
      showApplyBtn: false,
      inline: true,
      showSelectDateText: true,
      monthSelector: true,
    };

    this.myDatePickerOptions = {
      dateFormat: "mmm dd, yyyy",
      minYear: +this.currentYear,
      firstDayOfWeek: "su",
      disableUntil: {
        year: +this.currentYear,
        month: +this.currentMonth,
        day: +this.currentDate,
      },
      // maxYear: +this.currentYear,
      showClearDateBtn: false,
      editableDateField: false,
      showInputField: false,
      inline: false,
      disableDays: this.disableDaysArray,
    };
  }

  ngOnInit() {
    this.getAllTechnicians();
    const calender = this.calenderView();
    this.viewTestCenter();
    const todayNew = this.calenderToday;
    const todayMonth = todayNew.getMonth() + 1;
    const todayYear = todayNew.getFullYear();
    let todayMonthStr;
    if (todayMonth.toString().length === 1) {
      todayMonthStr = "0" + todayMonth;
    } else {
      todayMonthStr = "" + todayMonth;
    }
    const data = {
      type: "month",
      startDate: todayYear + "-" + todayMonthStr + "-01",
    };
    this.calendarTitle = calender.view.title;
    this.getAllTechWorkHoursNew(data);
  }

  openModal(template: TemplateRef<any>) {
    setTimeout(() => {
      if (this.eventInfoData) {
        this.modalRef = this.modalService.show(
          template,
          Object.assign(this.config, { class: "popup-center" })
        );
      }
    }, 2000);
  }

  calenderView() {
    const obj = this;
    const calendarEl = document.getElementById("calendarWorkHours");
    calendarEl.innerHTML = "";

    this.workHoursCalenderData = this.workHoursCalenderData.concat(
      this.workHoursCalenderDataOff
    );

    const calender = new Calendar(calendarEl, {
      schedulerLicenseKey: "0569894629-fcs-1563784117",
      plugins: [dayGridPlugin],
      defaultView: "dayGridMonth",
      timeZone: "UTC",
      events: this.workHoursCalenderData,
      eventClick: this.eventInfo,
      eventRender: function (view) {
        obj.calendarTitle = view.view.title;
      },
      showNonCurrentDates: false,
      fixedWeekCount: false,
      header: false,
      // header: {
      //   left: 'prev,next today',
      //   center: 'title',
      //   right: 'dayGridMonth'
      // },
    });
    calender.gotoDate(this.calenderToday);
    calender.render();
    this.calender = calender;
    return calender;
  }

  eventInfo(info) {
    this.eventInfoData = info["event"]["_def"]["title"];
    if (info["event"]["_def"]["title"] !== "Closed") {
      $("#template").modal("show");
      $("#infoData").html(info["event"]["_def"]["title"]);
    }
  }

  hideModal() {
    $("#template").modal("hide");
  }

  ownEventRender(event) {
    const element = event.el as HTMLElement;
  }

  clearSearch() {
    this.selectedTechnicianId = "";
    this.searchTech = "";
    this.cancelEditTechWorkHours();
  }

  clearSearchView() {
    this.selectTechIdView1 = "";
    this.searchTechView = "";
    this.viewTechWorkHours = [];
  }

  setTechID(id, fname, lname) {
    this.searchTech = fname + " " + lname;
    this.selectedTechnicianId = id;
    this.editTechWorkHoursData = false;
    this.getTechWorkHoursByID(id, "", "", "");
    this.emptyTechWorkHours();
    this.enableRangeCalender();
  }

  private createEmptyTechWorkHoursData() {
    return {
      workFromDate: "",
      workFromDateStr: "",
      workToDate: "",
      workToDateStr: "",
      workFromTime: "",
      workToTime: "",
      lunchFromTime: "",
      lunchToTime: "",
      excludeDateStr: "",
      excludedDate: "",
      toWorkHoursArray: [],
      fromLunchHoursArray: [],
      toLunchHoursArray: [],
      time1: "",
      time2: "",
      time3: "",
      time4: "",
      techid: this.selectedTechnicianId,
    };
  }

  addNewTechWorkHoursArray() {
    const newData = this.createEmptyTechWorkHoursData();
    this.addedTechWorkHoursArray.push(newData);
  }

  emptyTechWorkHours() {
    this.addedTechWorkHoursArray = [];
    const newData = this.createEmptyTechWorkHoursData();
    this.addedTechWorkHoursArray.push(newData);

    this.disableDaysArray = [];
    this.disableDateRangeArray = [];
    this.myDateRangePickerOptions = {
      dateFormat: "mmm dd, yyyy",
      minYear: +this.currentYear,
      firstDayOfWeek: "su",
      disableUntil: {
        year: +this.currentYear,
        month: +this.currentMonth,
        day: +this.currentDate,
      },
      showClearDateRangeBtn: false,
      showClearBtn: false,
      showApplyBtn: false,
      inline: true,
      disableDateRanges: this.disableDateRangeArray,
      showSelectDateText: false,
    };

    this.myDatePickerOptions = {
      dateFormat: "mmm dd, yyyy",
      minYear: +this.currentYear,
      firstDayOfWeek: "su",
      disableUntil: {
        year: +this.currentYear,
        month: +this.currentMonth,
        day: +this.currentDate,
      },
      showClearDateBtn: false,
      editableDateField: false,
      showInputField: false,
      inline: false,
      disableDays: this.disableDaysArray,
    };
    this.selectedDateRange = null;
    this.time1 = "";
    this.time2 = "";
    this.time3 = "";
    this.time4 = "";
  }

  getAllTechnicians() {
    const data = {
      testcenterId: localStorage.getItem("testCenterId"),
      pageNumber: 0,
      pageSize: 0,
      sortColumn: "createdOn",
      sortType: "desc",
    };
    this.appservice.getAllTechnicianByTestCenter(data).subscribe(
      (res) => {
        if (res && res["status"] && res["status"]["status"] === 200) {
          this.allTechnician = res["entity"];
        }
      },
      (err) => {
        this.appservice.sessionOut(err);
      }
    );
  }

  onDateRangeChanged(event: IMyDateRangeModel) {
    this.beginJsDate = event.beginJsDate;
    this.endJsDate = event.endJsDate;
    const formattedDate = event.formatted.split("-");
    const addTechlength = this.addedTechWorkHoursArray.length;
    this.addedTechWorkHoursArray[addTechlength - 1].selectedbeginDateformatted =
      formattedDate[0];
    this.addedTechWorkHoursArray[addTechlength - 1].selectedendDateformatted =
      formattedDate[1];
    this.addedTechWorkHoursArray[addTechlength - 1].workFromDate =
      event.beginDate.year +
      "-" +
      this.checkDate(event.beginDate.month) +
      "-" +
      this.checkDate(event.beginDate.day);
    this.addedTechWorkHoursArray[addTechlength - 1].workToDate =
      event.endDate.year +
      "-" +
      this.checkDate(event.endDate.month) +
      "-" +
      this.checkDate(event.endDate.day);

    this.addedTechWorkHoursArray[addTechlength - 1].workFromDateStr =
      event.beginDate.year +
      "-" +
      this.checkDate(event.beginDate.month) +
      "-" +
      this.checkDate(event.beginDate.day);
    this.addedTechWorkHoursArray[addTechlength - 1].workToDateStr =
      event.endDate.year +
      "-" +
      this.checkDate(event.endDate.month) +
      "-" +
      this.checkDate(event.endDate.day);
    // this.addedTechWorkHoursArray[addTechlength-1].excludeDateStr = '';
    // this.addedTechWorkHoursArray[addTechlength-1].excludedDate = '';
    this.clearExcludedDate(addTechlength - 1);
    this.currentSelectedRange = event;

    this.selectedDateRange = {
      beginDate: event.beginDate,
      endDate: event.endDate,
    };
  }

  onDateChanged(event, index) {
    this.jsdate = event.jsdate;
    if (this.jsdate >= this.beginJsDate && this.jsdate <= this.endJsDate) {
      this.disableDaysArray = this.disableDaysArray.concat(event.date);
      this.myDatePickerOptions = {
        dateFormat: "mmm dd, yyyy",
        minYear: +this.currentYear,
        firstDayOfWeek: "su",
        disableUntil: {
          year: +this.currentYear,
          month: +this.currentMonth,
          day: +this.currentDate,
        },
        showClearDateBtn: false,
        editableDateField: false,
        showInputField: false,
        inline: false,
        disableDays: this.disableDaysArray,
      };

      if (event && event.formatted) {
        if (this.addedTechWorkHoursArray[index].excludedDate) {
          this.addedTechWorkHoursArray[index].excludedDate =
            this.addedTechWorkHoursArray[index].excludedDate +
            event.formatted +
            ", ";
        } else {
          this.addedTechWorkHoursArray[index].excludedDate = event.formatted;
        }

        if (this.addedTechWorkHoursArray[index].excludeDateStr) {
          this.addedTechWorkHoursArray[index].excludeDateStr =
            this.addedTechWorkHoursArray[index].excludeDateStr +
            "," +
            event.date.year +
            "-" +
            this.checkDate(event.date.month) +
            "-" +
            this.checkDate(event.date.day);
        } else {
          this.addedTechWorkHoursArray[index].excludeDateStr =
            event.date.year +
            "-" +
            this.checkDate(event.date.month) +
            "-" +
            this.checkDate(event.date.day);
        }
      }
    } else {
      this.showErrorMessage =
        "Please select the excluded date from the Selected date range";
      setTimeout(() => {
        this.showErrorMessage = "";
      }, 5000);
    }
  }

  clearExcludedDate(index) {
    this.addedTechWorkHoursArray[index].excludedDate = "";
    this.addedTechWorkHoursArray[index].excludeDateStr = "";
    this.addedTechWorkHoursArray[index].excludedDateStr = "";
    this.disableDaysArray = [];
    this.myDatePickerOptions = {
      dateFormat: "mmm dd, yyyy,",
      minYear: +this.currentYear,
      firstDayOfWeek: "su",
      disableUntil: {
        year: +this.currentYear,
        month: +this.currentMonth,
        day: +this.currentDate,
      },
      showClearDateBtn: false,
      editableDateField: false,
      showInputField: false,
      inline: false,
      disableDays: this.disableDaysArray,
    };
  }

  addTechWorkHoursArray(data) {
    if (
      data.lunchFromTime &&
      data.lunchToTime &&
      data.techid &&
      data.workFromDate &&
      data.workFromTime &&
      data.workToDate &&
      data.workToTime
    ) {
      if (this.addedTechWorkHoursArray.length === 1) {
        this.disableDateRangeArray = [];
      }
      this.disableDateRangeArray = this.disableDateRangeArray.concat(
        this.currentSelectedRange
      );
      this.myDateRangePickerOptions = {
        // other options...
        dateFormat: "mmm dd, yyyy",
        minYear: +this.currentYear,
        firstDayOfWeek: "su",
        disableUntil: {
          year: +this.currentYear,
          month: +this.currentMonth,
          day: +this.currentDate,
        },
        showClearDateRangeBtn: false,
        showClearBtn: false,
        showApplyBtn: false,
        inline: true,
        disableDateRanges: this.disableDateRangeArray,
        showSelectDateText: false,
      };
      this.addNewTechWorkHoursArray();
    } else {
      this.showErrorMessage = "Please fill all the fields";
      setTimeout(() => {
        this.showErrorMessage = "";
      }, 5000);
    }
  }

  removeTechWorkHoursArray(index) {
    this.addedTechWorkHoursArray.splice(index, 1);
    this.disableDateRangeArray.splice(index, 1);
    if (this.addedTechWorkHoursArray.length === 0) {
      this.addNewTechWorkHoursArray();
    }
    this.myDateRangePickerOptions = {
      // other options...
      dateFormat: "mmm dd, yyyy",
      minYear: +this.currentYear,
      firstDayOfWeek: "su",
      disableUntil: {
        year: +this.currentYear,
        month: +this.currentMonth,
        day: +this.currentDate,
      },
      showClearDateRangeBtn: false,
      showClearBtn: false,
      showApplyBtn: false,
      inline: true,
      disableDateRanges: this.disableDateRangeArray,
      showSelectDateText: false,
    };
  }

  private validateTechWorkHoursArray() {
    let valid = true;
    for (let i = 0; i < this.addedTechWorkHoursArray.length; i++) {
      if (
        this.addedTechWorkHoursArray[i].workFromDate &&
        this.addedTechWorkHoursArray[i].workToDate &&
        this.addedTechWorkHoursArray[i].workFromTime &&
        this.addedTechWorkHoursArray[i].workToTime &&
        this.addedTechWorkHoursArray[i].lunchFromTime &&
        this.addedTechWorkHoursArray[i].lunchToTime
      ) {
        // console.log("success");
      } else {
        valid = false;
        this.showErrorMessage = "Please fill all the fields";
        setTimeout(() => {
          this.showErrorMessage = "";
        }, 5000);
        break;
      }
    }
    return valid;
  }

  saveTechWorkHours() {
    const valid = this.validateTechWorkHoursArray();
    if (valid === true) {
      const data = {
        hrInputs: this.addedTechWorkHoursArray,
      };
      this.appservice.saveTechWorkHours(data).subscribe((res) => {
        if (res && res["status"] && res["status"]["status"] === 200) {
          this.showSuccessMessage = "Added Successfully";
          this.getTechWorkHoursByID(this.selectTechId, "", "", "");
          setTimeout(() => {
            this.showSuccessMessage = "";
          }, 5000);
          this.emptyTechWorkHours();
          this.goToToday();
        } else if (res && res["status"] && res["status"]["status"] === 230) {
          this.showErrorMessage = res["status"]["msg"];
          setTimeout(() => {
            this.showErrorMessage = "";
          }, 5000);
        } else if (res && res["status"] && res["status"]["status"] === 229) {
          this.showErrorMessage = "Selected date range is already exist";
          setTimeout(() => {
            this.showErrorMessage = "";
          }, 5000);
        } else if (res && res["status"] && res["status"]["status"] === 241) {
          this.showErrorMessage =
            "Selected date must be before terminated date";
          setTimeout(() => {
            this.showErrorMessage = "";
          }, 5000);
        }
      });
    }
  }

  getTechWorkHoursByID(id, fname, lname, type) {
    this.searchTechView = fname + " " + lname;
    this.selectTechIdView1 = id;
    this.selectTechIdViewFName = fname;
    this.selectTechIdViewLName = lname;
    const data = {
      techId: id,
    };

    this.appservice.getTechWorkHours(data).subscribe((res) => {
      if (res && res["status"] && res["status"]["status"] === 200) {
        this.viewTechWorkHours = res["entity"];
      } else {
        if (type === "delete") {
          this.showErrorMessage = "";
        }
        setTimeout(() => {
          this.showErrorMessage = "";
        }, 5000);
        this.viewTechWorkHours = [];
      }
    });
  }

  delectTechWorkHoursById(id) {
    this.appservice.deleteOneTechWorkHour(id).subscribe((res) => {
      if (res && res["status"] && res["status"]["status"] === 200) {
        this.showSuccessMessage = "Deleted Successfully";
        setTimeout(() => {
          this.showSuccessMessage = "";
        }, 5000);
        this.getTechWorkHoursByID(
          this.selectTechIdView1,
          this.selectTechIdViewFName,
          this.selectTechIdViewLName,
          "delete"
        );
        this.today = new Date();
        this.getAllTechWorkHoursNew("");
      } else {
        this.showErrorMessage = "Not able to delete";
        setTimeout(() => {
          this.showErrorMessage = "";
        }, 5000);
      }
    });
    this.cancelEditTechWorkHours();
  }

  scrollTop(value) {
    document.getElementById(value).scrollIntoView({ behavior: "smooth" });
  }

  editTechWorkHours(viewData) {
    this.scrollTop("editdiv");
    this.selectedDateRange = null;
    this.viewRangeCalender = false;
    this.searchTech = viewData.techFirstName + " " + viewData.techLastName;
    this.selectTechId = viewData.technicianId;
    this.selectedTechnicianId = viewData.technicianId;
    this.editTechWorkHoursData = true;
    this.addedTechWorkHoursArray = [];
    viewData.toWorkHoursArray = [];
    viewData.fromLunchHoursArray = [];
    viewData.toLunchHoursArray = [];
    this.addedTechWorkHoursArray.push(viewData);
    this.addedTechWorkHoursArray[0].workFromDate = viewData.workFromDateStr;
    this.addedTechWorkHoursArray[0].workToDate = viewData.workToDateStr;

    if (viewData.workToDateStr && viewData.workFromDateStr) {
      const fromdate = viewData.workFromDateStr.split("-");
      const todate = viewData.workToDateStr.split("-");
      if (fromdate.length > 0 && todate.length > 0) {
        this.selectedDateRange = {
          beginDate: {
            year: +fromdate[0],
            month: +fromdate[1],
            day: +fromdate[2],
          },
          endDate: { year: +todate[0], month: +todate[1], day: +todate[2] },
        };
      }
    }

    this.addedTechWorkHoursArray[0].selectedbeginDateformatted =
      viewData.workFromDateStr;
    this.addedTechWorkHoursArray[0].selectedendDateformatted =
      viewData.workToDateStr;
    this.addedTechWorkHoursArray[0].excludedDate = viewData.excludedDate;
    this.addedTechWorkHoursArray[0].techid = viewData.technicianId;
    this.addedTechWorkHoursArray[0].excludeDateStr = viewData.excludedDateStr;

    this.addedTechWorkHoursArray[0].time1 = viewData.workFromTime;
    this.time1 = viewData.workFromTime;
    this.getFromWorkHoursIndex(this.time1, 0);

    this.addedTechWorkHoursArray[0].time2 = viewData.workToTime;
    this.time2 = viewData.workToTime;
    this.getToWorkHoursIndex(this.time2, 0);

    this.addedTechWorkHoursArray[0].time3 = viewData.lunchFromTime;
    this.time3 = viewData.lunchFromTime;
    this.getFromLunchHoursIndex(this.time3, 0);

    this.addedTechWorkHoursArray[0].time4 = viewData.lunchToTime;
    this.time4 = viewData.lunchToTime;
    this.getToLunchHoursIndex(this.time4, 0);
    this.disableDateRangeArray = [];

    this.myDateRangePickerOptions = {
      // other options...
      dateFormat: "mmm dd, yyyy",
      minYear: +this.currentYear,
      firstDayOfWeek: "su",
      disableUntil: {
        year: +this.currentYear,
        month: +this.currentMonth,
        day: +this.currentDate,
      },
      showClearDateRangeBtn: false,
      showClearBtn: false,
      showApplyBtn: false,
      inline: true,
      disableDateRanges: this.disableDateRangeArray,
      showSelectDateText: false,
    };
    this.beginJsDate = new Date(viewData.workFromDateStr);
    this.endJsDate = new Date(viewData.workToDateStr);
  }

  enableRangeCalender() {
    this.viewRangeCalender = true;
  }

  cancelEditTechWorkHours() {
    this.editTechWorkHoursData = false;
    this.emptyTechWorkHours();
    this.enableRangeCalender();
  }

  UpdateTechWorkHours() {
    const valid = this.validateTechWorkHoursArray();
    if (valid === true) {
      const data = {
        hrInputs: this.addedTechWorkHoursArray,
      };
      this.appservice.saveTechWorkHours(data).subscribe((res) => {
        if (res && res["status"] && res["status"]["status"] === 200) {
          this.showSuccessMessage = "Updated Successfully";
          setTimeout(() => {
            this.showSuccessMessage = "";
          }, 5000);
          this.editTechWorkHoursData = false;
          this.emptyTechWorkHours();
          this.goToToday();
          this.getTechWorkHoursByID(
            this.selectTechIdView1,
            this.selectTechIdViewFName,
            this.selectTechIdViewLName,
            "update"
          );
        } else if (res && res["status"] && res["status"]["status"] === 230) {
          this.showErrorMessage = res["status"]["msg"];
          setTimeout(() => {
            this.showErrorMessage = "";
          }, 5000);
        } else if (res && res["status"] && res["status"]["status"] === 229) {
          this.showErrorMessage = "Selected date range is already exist";
          setTimeout(() => {
            this.showErrorMessage = "";
          }, 5000);
        }
      });
    }
  }

  getAllTechWorkHoursNew(datavalue) {
    this.appservice.getAllWorkHoursTechnician().subscribe(
      (res) => {
        if (res && res["entity"]) {
          this.workHoursCalenderData = [];
          this.viewAllTechWorkHours = res["entity"];
          this.viewAllTechWorkHours.forEach((obj) => {
            this.workHoursCalenderData = this.workHoursCalenderData.concat({
              title:
                obj.techFirstName +
                " " +
                obj.techLastName +
                " WH - " +
                obj.workFromTime +
                " to " +
                obj.workToTime +
                " LH - " +
                obj.lunchFromTime +
                " to " +
                obj.lunchToTime,
              start: obj.workDateStr,
              textColor: "white",
              allDay: true,
            });
          });
          this.workHoursCalenderDataOff = [];
          if (datavalue) {
            this.calenderToday = new Date(datavalue.startDate);
          }
          this.calenderView();
          this.getAllOFf(datavalue);
        } else {
          this.workHoursCalenderDataOff = [];
        }
      },
      (err) => {
        this.workHoursCalenderDataOff = [];
        this.getAllOFf(datavalue);
      }
    );
  }

  getAllOFf(datavalue) {
    const dataNew = {
      startDate: datavalue.startDate,
    };

    this.appservice.getAllWeekOff(dataNew).subscribe(
      (res) => {
        if (res && res["entity"]) {
          this.workHoursCalenderDataOff = [];
          this.viewAllOff = res["entity"];
          this.viewAllOff.forEach((obj) => {
            this.workHoursCalenderDataOff = this.workHoursCalenderDataOff.concat(
              {
                title: "Closed",
                start: obj.workDateStr,
                textColor: "black",
                color: "#c0c0c0",
                allDay: true,
              }
            );
          });
          this.calenderView();
        }
      },
      (err) => {}
    );
  }

  getAllTechWorkHours() {
    this.appservice.getAllTechWorkHoursData().subscribe(
      (res) => {
        if (res && res["entity"]) {
          this.workHoursCalenderData = [];
          this.viewAllTechWorkHours = res["entity"];
          this.viewAllTechWorkHours.forEach((obj) => {
            let month1Str = "";
            let day1Str = "";
            const fromDate1 = new Date(obj.workFromDateStr);
            const day1 = fromDate1.getDate();
            const month1 = fromDate1.getMonth() + 1;
            const year1 = fromDate1.getFullYear();
            if (month1.toString().length === 1) {
              month1Str = "0" + month1;
            } else {
              month1Str = "" + month1;
            }

            if (day1.toString().length === 1) {
              day1Str = "0" + day1;
            } else {
              day1Str = "" + day1;
            }

            let month2Str = "";
            let day2Str = "";

            var toDate = new Date(obj.workToDateStr);
            // add a day
            toDate.setDate(toDate.getDate() + 1);
            const day2added = toDate.getDate();

            if (day2added.toString().length === 1) {
              day2Str = "0" + day2added;
            } else {
              day2Str = "" + day2added;
            }

            const toDate1 = new Date(toDate);
            const month2 = toDate1.getMonth() + 1;
            const year2 = toDate1.getFullYear();
            if (month2.toString().length === 1) {
              month2Str = "0" + month2;
            } else {
              month2Str = "" + month2;
            }

            this.workHoursCalenderData = this.workHoursCalenderData.concat({
              title:
                obj.techFirstName +
                " " +
                obj.techLastName +
                " WH - " +
                obj.workFromTime +
                " to " +
                obj.workToTime +
                " LH - " +
                obj.lunchFromTime +
                " to " +
                obj.lunchToTime,
              start: year1 + "-" + month1Str + "-" + day1Str,
              end: year2 + "-" + month2Str + "-" + day2Str,
              textColor: "white",
              allDay: true,
            });
          });
          this.calenderView();
        }
      },
      (err) => ({})
    );
  }

  getMonthNumberBymonthName(valuearray): string {
    let month = 0;

    const value = valuearray.toString().split(" ");
    if (value.length > 1) {
      if (value[0] === "January") {
        month = 1;
      } else if (value[0] === "February") {
        month = 2;
      } else if (value[0] === "March") {
        month = 3;
      } else if (value[0] === "April") {
        month = 4;
      } else if (value[0] === "May") {
        month = 5;
      } else if (value[0] === "June") {
        month = 6;
      } else if (value[0] === "July") {
        month = 7;
      } else if (value[0] === "August") {
        month = 8;
      } else if (value[0] === "September") {
        month = 9;
      } else if (value[0] === "October") {
        month = 10;
      } else if (value[0] === "November") {
        month = 11;
      } else if (value[0] === "December") {
        month = 12;
      }
    }

    return value[1] + "-" + month + "-" + "01";
  }

  gotoLeft() {
    if (this.calender) {
      this.calender.prev();
      const todayNew = this.getMonthNumberBymonthName(this.calender.view.title)
        .toString()
        .split("-");
      const todayMonth = todayNew[1];
      const todayYear = todayNew[0];
      let todayMonthStr;

      if (todayMonth.toString().length === 1) {
        todayMonthStr = "0" + todayMonth;
      } else {
        todayMonthStr = "" + todayMonth;
      }

      const data = {
        type: "month",
        startDate: todayYear + "-" + todayMonthStr + "-01",
      };

      this.getAllTechWorkHoursNew(data);
    }
  }

  gotoRight() {
    if (this.calender) {
      this.calender.next();
      const todayNew = this.getMonthNumberBymonthName(this.calender.view.title)
        .toString()
        .split("-");
      const todayMonth = todayNew[1];
      const todayYear = todayNew[0];
      let todayMonthStr;
      if (todayMonth.toString().length === 1) {
        todayMonthStr = "0" + todayMonth;
      } else {
        todayMonthStr = "" + todayMonth;
      }

      const data = {
        type: "month",
        startDate: todayYear + "-" + todayMonthStr + "-01",
      };

      this.getAllTechWorkHoursNew(data);
    }
  }

  goToToday() {
    if (this.calender) {
      this.calender.today();
      this.calenderToday = this.calender.getDate();
      const todayNew = this.calenderToday;
      const todayMonth = todayNew.getMonth() + 1;
      var todayYear = todayNew.getFullYear();
      var todayMonthStr;
      if (todayMonth.toString().length === 1) {
        todayMonthStr = "0" + todayMonth;
      } else {
        todayMonthStr = "" + todayMonth;
      }
    }
    const data = {
      type: "month",
      startDate: todayYear + "-" + todayMonthStr + "-01",
    };
    this.getAllTechWorkHoursNew(data);
  }

  getFromWorkHoursIndexNew(key) {
    this.selectedWorkHoursFromIndex = key;
    const floatKey = parseFloat(key);
    this.toWorkHoursArrayNew = {};
    for (const keys in environment.initialTimeNew) {
      const keysFLoat = parseFloat(keys);
      if (floatKey < keysFLoat && this.toHoursHighValue > keysFLoat) {
        this.toWorkHoursArrayNew[keys] = environment.initialTimeNew[keys];
      }
    }
    return this.toWorkHoursArrayNew;
  }

  getToWorkHoursIndexNew(key) {
    this.selectedWorkHoursToIndex = parseFloat(key);
    this.toWorkHoursArrayNew = {};
    for (const keys in environment.initialTimeNew) {
      const keysFLoat = parseFloat(keys);
      if (
        this.selectedWorkHoursToIndex > keysFLoat &&
        this.selectedWorkHoursFromIndex < keysFLoat
      ) {
        this.toWorkHoursArrayNew[keys] = environment.initialTimeNew[keys];
      }
    }
    return this.toWorkHoursArrayNew;
  }

  getFromLunchHoursIndexNew(key) {
    this.selectedLunchHoursFromIndex = parseFloat(key);
    this.toWorkHoursArrayNew = {};
    for (const keys in environment.initialTimeNew) {
      const keysFLoat = parseFloat(keys);
      if (
        this.selectedLunchHoursFromIndex < keysFLoat &&
        this.selectedWorkHoursToIndex > keysFLoat
      ) {
        this.toWorkHoursArrayNew[keys] = environment.initialTimeNew[keys];
      }
    }
    return this.toWorkHoursArrayNew;
  }

  getFromWorkHoursIndex(value, index) {
    environment.initialTimeNewObject.forEach((obj) => {
      if (obj.value === value) {
        this.selectedTime1Object = obj;
      }
    });
    const keyNew = this.selectedTime1Object;
    this.addedTechWorkHoursArray[index].workFromTime = keyNew.value;
    const floatKey = parseFloat(keyNew.key);
    this.selectedWorkHoursFromIndex = parseFloat(keyNew.key);
    environment.initialTimeNewObject.forEach((obj) => {
      const keysFLoat = parseFloat(obj.key);
      if (floatKey < keysFLoat && this.toHoursHighValue > keysFLoat) {
        this.addedTechWorkHoursArray[index].toWorkHoursArray.push(obj);
      }
    });
  }

  getToWorkHoursIndex(value, index) {
    environment.initialTimeNewObject.forEach((obj) => {
      if (obj.value === value) {
        this.selectedTime2Object = obj;
      }
    });
    const keyNew = this.selectedTime2Object;
    this.addedTechWorkHoursArray[index].workToTime = keyNew.value;
    this.selectedWorkHoursToIndex = parseFloat(keyNew.key);
    environment.initialTimeNewObject.forEach((obj) => {
      const keysFLoat = parseFloat(obj.key);
      if (
        this.selectedWorkHoursToIndex > keysFLoat &&
        this.selectedWorkHoursFromIndex < keysFLoat
      ) {
        this.addedTechWorkHoursArray[index].fromLunchHoursArray.push(obj);
      }
    });
  }

  getFromLunchHoursIndex(value, index) {
    environment.initialTimeNewObject.forEach((obj) => {
      if (obj.value === value) {
        this.selectedTime3Object = obj;
      }
    });
    const keyNew = this.selectedTime3Object;
    this.addedTechWorkHoursArray[index].lunchFromTime = keyNew.value;
    this.selectedLunchHoursFromIndex = parseFloat(keyNew.key);
    environment.initialTimeNewObject.forEach((obj) => {
      const keysFLoat = parseFloat(obj.key);
      if (
        this.selectedLunchHoursFromIndex < keysFLoat &&
        this.selectedWorkHoursToIndex > keysFLoat
      ) {
        this.addedTechWorkHoursArray[index].toLunchHoursArray.push(obj);
      }
    });
  }

  getToLunchHoursIndex(value, index) {
    environment.initialTimeNewObject.forEach((obj) => {
      if (obj.value === value) {
        this.selectedTime4Object = obj;
      }
    });
    const keyNew = this.selectedTime4Object;
    this.addedTechWorkHoursArray[index].lunchToTime = keyNew.value;
  }
  viewTestCenter() {
    this.appservice.viewtestcenter().subscribe((res) => {
      if (res && res["status"] && res["status"]["status"] === 200) {
        if (res["entity"]) {
          this.workingHours = res["entity"]["workingHours"];
          this.setCalendarTime();
        }
      }
    });
  }

  setCalendarTime() {
    const getDate = moment(this.today).format("dddd");
    if (this.workingHours.length > 0) {
      days.forEach((day) => {
        if (day.value === getDate) {
          this.workingHours.forEach((work) => {
            if (work.workHourType === "work") {
              this.convertFromTimeformat(work.fromHour);
              this.convertToTimeformat(work.toHour);
            }
          });
        }
      });
    }
  }

  private parseTimeToFloat(str) {
    const time = str;
    let hours = Number(time.match(/^(\d+)/)[1]);
    const minutes = Number(time.match(/:(\d+)/)[1]);
    const AMPM = time.match(/\s(AM|PM)$/i)[1];
    if (AMPM === "PM" && hours < 12) {
      hours = hours + 12;
    }
    if (AMPM === "AM" && hours === 12) {
      hours = hours - 12;
    }
    let sHours = hours.toString();
    let sMinutes = minutes.toString();
    if (hours < 10) {
      sHours = "0" + sHours;
    }
    if (minutes < 10) {
      sMinutes = "0" + sMinutes;
    }
    const result = parseFloat(sHours + "." + sMinutes);
    return result;
  }

  convertFromTimeformat(str) {
    const result = this.parseTimeToFloat(str);
    if (this.fromHourslowValue === 0) {
      this.fromHourslowValue = result;
    }
    if (result <= this.fromHourslowValue) {
      this.fromHourslowValue = result;
    }
  }

  convertToTimeformat(str) {
    const result = this.parseTimeToFloat(str);
    if (this.toHoursHighValue === 0) {
      this.toHoursHighValue = result;
    }
    if (result >= this.toHoursHighValue) {
      this.toHoursHighValue = result;
    }
  }

  convertToKey(str) {
    const time = str;
    let hours = Number(time.match(/^(\d+)/)[1]);
    const minutes = Number(time.match(/:(\d+)/)[1]);
    const AMPM = time.match(/\s(AM|PM)$/i)[1];
    if (AMPM === 'PM' && hours < 12) {
      hours = hours + 12;
    }
    if (AMPM === "AM" && hours === 12) {
      hours = hours - 12;
    }
    let sHours = hours.toString();
    let sMinutes = minutes.toString();
    if (hours < 10) {
      sHours = "0" + sHours;
    }
    if (minutes < 10) {
      sMinutes = "0" + sMinutes;
    }
    const result = parseFloat(sHours + "." + sMinutes);
    return result;
  }

  checkDate(str) {
    return checkDateUtil(str);
  }
}
